import React from 'react';
import './datenschutz.css';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';
import { Header } from '../../components/header/Header';

const Datenschutz = () => {
	return (
		<div>
            <Header/>
			<section className='datenschutz-section'>
				<div className='datenschutz-container'>
					<h1 className='datenschutz-title'><span style={{ color: '#6C5CE7' }}>Datenschutz</span> bei Erledix</h1>

					<div className='datenschutz-content'>
						<p>
							Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir, die{' '}
							<strong>Health365 IT GmbH</strong>, betreiben die spielerische To-Do-App{' '}
							<strong>Erledix</strong> und möchten Sie im Folgenden über die
							Verarbeitung Ihrer Daten informieren. Diese Datenschutzerklärung
							erläutert, welche Daten wir sammeln, wie wir sie verwenden und welche
							Rechte Sie haben.
						</p>

						<h2>Datenverarbeitung</h2>
						<p>
							Wir erheben und verarbeiten Ihre Daten, um Ihnen die Nutzung von Erledix
							zu ermöglichen und unsere Dienste zu verbessern. Dazu gehören Daten, die
							Sie uns bei der Registrierung mitteilen (z. B. Name, E-Mail-Adresse)
							sowie Nutzungsdaten (z. B. Aufgaben, Coins, Belohnungen). Wir nutzen
							diese Daten, um Ihnen personalisierte Inhalte anzuzeigen und Ihnen bei
							der Organisation Ihrer Aufgaben zu helfen.
						</p>

						<h2>Cookies und Analyse-Tools</h2>
						<h3>Cookies</h3>
						<p>
							Wir verwenden Cookies, um die Nutzung von Erledix zu analysieren und
							unsere Dienste zu verbessern. Cookies sind kleine Textdateien, die auf
							Ihrem Gerät gespeichert werden. Sie können die Verwendung von Cookies in
							Ihren Browsereinstellungen deaktivieren. Beachten Sie jedoch, dass dies
							die Funktionalität von Erledix beeinträchtigen kann.
						</p>

						<h3>Plausible Analytics</h3>
						<p>
							Diese Website nutzt <strong>Plausible Analytics</strong>, einen
							datenschutzfreundlichen Webanalysedienst. Plausible Analytics verwendet
							keine Cookies und speichert keine personenbezogenen Daten. Die Analyse
							erfolgt ausschließlich auf aggregierter Basis, um das Nutzerverhalten
							auf unserer Website zu verstehen und unser Angebot zu verbessern. Die
							Daten werden innerhalb der EU gehostet. Weitere Informationen finden Sie
							unter{' '}
							<a
								href='https://plausible.io/privacy'
								target='_blank'
								rel='noopener noreferrer'
								className='link-style'
							>
								plausible.io/privacy
							</a>
							.
						</p>

						<h2>Ihre Rechte</h2>
						<p>
							Sie haben das Recht auf Auskunft, Berichtigung, Löschung und
							Einschränkung der Verarbeitung Ihrer Daten. Bitte kontaktieren Sie uns
							unter <a href='mailto:info@h365.de' className='link-style'>info@h365.de</a>, um Ihre Rechte
							auszuüben.
						</p>
					</div>
				</div>
			</section>
			<MobileFooter />
		</div>
	);
};

export default Datenschutz;
